// To prevent jshint errors
/*global Modernizr:true */
/*jshint devel:true */
/*global $:false */

jQuery('#gc-select').on('change', function(event) {
    event.preventDefault();
    var locationId = jQuery(this).val();
    geturl(locationId);
});

// Using ajax, to get gallery image urls
function geturl(locationId) {
    "use strict";

    // console.log(locationId);

    var data = {
        action: 'get_gc',
        gift_card_nonce: gc_vars.gc_nonce,
        location_id: locationId
    };

    jQuery.ajax({
        type: 'post',
        dataType: 'json',
        url: gc_vars.gc_ajax_url,
        data: data,
        beforeSend: function() {
            jQuery('#gc-button').html( 'Loading...' );
            jQuery('#gc-button').addClass('disabled');
        },
        success: function( data, textStatus, jqXHR ) {
            console.log(data);

            jQuery('#gc-button').attr('href', data);
            jQuery('#gc-button').html( 'Buy Now' );
            jQuery('#gc-button').removeClass('disabled');
        },
        error: function( MLHttpRequest, textStatus, errorThrown ) {
            // console.log(errorThrown);
        }
    });
}